/**
 * Created by seaasun on 2017/11/24.
 */
import Vue from 'vue'
import state from './state.js'

export default {
  namespaced: true,
  state,
  getters: {
    fullUrl: state => name => {
      return state.root + state[name]
    },
    showPromotion: state => {
      let showPromotion = state.ShowPromotion || false
      let IsUserNoPay = state.IsUserNoPay || false
      // TODO Promotion
      return showPromotion && IsUserNoPay
    },
    userImg: state => {
      if (state.UserImg) {
        return state.UserImg
      } else {
        return 'data:image/png;base64,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'
      }
    },
    enablePlaceOrder: state => {
      return state.IsPlaceOrderEnabled && !state.IsUserNoPay
    }
  },
  mutations: {
    setRootUrl (state, url) {
      state.root = url
    },
    saveSite (state, values) {
      for (let key of Object.keys(values)) {
        Vue.set(state, key, values[key])
      }
    },
    saveKey (state, val) {
      Vue.set(state, val[0], val[1])
    }
  },
  actions: {
    init ({commit, rootState}) {
      Vue.http.post('PlaceOrder.aspx/InitializeCommonJsConfiguration', {})
        .then(resp => {
          if (process.env.NODE_ENV === 'production' && resp.body.d.DataSource.User_RoleName === 'Anonymous User') {
            // TODO@PONY need check
            // window.location.href = utils.getRootPath() + '/login.aspx'
          }

          let data = resp.body.d.DataSource
          data.User_FullName = data.User_FullName.replace('\\', '')
          commit('saveSite', data)

          if (!data.IsEnableMultiCount) {
            commit('config/deleteTabType', ['multiCount', 'geoTabs'], {root: true})
          }

          if (!data.EnableZipCodeOrCarrierRoute) {
            commit('config/deleteTabType', ['zipMap', 'geoTabs'], {root: true})
          }
          if (!data.IsMultipleAddress) {
            commit('config/deleteTabType', ['multiClosex', 'geoRadius'], {root: true})
          }
          if (!data.IsEnableMultiGeo) {
            commit('config/deleteTabType', ['moreArea', 'geoTabs'], {root: true})
          }
          if (!data.IsMultipleAddress) {
            commit('config/deleteTabType', ['acxiomZipRadius', 'geoRadius'], {root: true})
          }

          // TODO@PONY ((key == 7 || key == 19 || key == 20) && (page.global.isMyAcxiomPartnerUSite || page.global.isDatabilitiesUSite))
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/site/index.js